import React, {useEffect, useRef, useState} from 'react';
import {Bell} from "lucide-react";
import {useAppDispatch, useAppSelector} from "app/store/hook";
import {formatDistanceToNow} from "date-fns";
import {ko} from 'date-fns/locale';
import {FirebaseService} from "app/services/common/FirebaseService";
import {getMessages} from "app/guard/authGuard";
import ArcButton, {ButtonColor} from "../../arc/ArcButton";
import moment from "moment";
import {UserInfoModel} from "../../../model/ua/user-info";
import {readAllAlarmMessages} from "../../../reducers/alarmSlice";
import {useNavigate} from "react-router-dom";
import {toAppPath} from "app/utils/alarmUtil";

/** 새 알림 확인 간격(장외거래 요청·메시지 등). 화면이 보일 때만 확인한다 */
const POLL_MS = 120_000;
export default function AccountAlarm() {
  const dispatch = useAppDispatch();
  const userInfo: UserInfoModel = useAppSelector((state) => state.userInfo.userInfo);
  const alarmMessages: any = useAppSelector((state) => state.messagesAlarm.messagesAlarm);
  const alarmRef = useRef<HTMLLIElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo?.userId) return;
    const id = window.setInterval(() => { if (!document.hidden) getMessages(dispatch, userInfo); }, POLL_MS);
    return () => window.clearInterval(id);
  }, [dispatch, userInfo]);

  // 앱 안 경로면 같은 창에서 이동하고, 다른 사이트면 새 창으로 연다
  const go = (link?: string | null) => {
    if (!link) return;
    const path = toAppPath(link);
    setOpen(false);
    if (path) navigate(path);
    else window.open(link, "_blank", "noopener,noreferrer");
  };
  const handleClickAlarmBadge = (event: any) => {
    event.preventDefault();
    setOpen((prev) => !prev);
  }

  const handleClickAlarmClose = (event: any) => {
    event.preventDefault();
    setOpen(false);
  }

  const handleClickReadAllAlarm = () => {
    dispatch(readAllAlarmMessages(alarmMessages.filter((item: any) => item.readYn === 'N')));
    FirebaseService.getInstance().readAllMessage(alarmMessages.filter((item: any) => item.readYn === 'N')).then(resp => {
      if (resp) {
        if (resp.resultCode == "Y") {
          getMessages(dispatch, userInfo);

        }
      }
    })
  }

  const handleClickAlarmNavigate = (event: any, item: any) => {
    event.preventDefault();
    if (item.readYn == "N") {
      FirebaseService.getInstance().readMessage(item).then(resp => {
        if (resp) {
          if (resp.resultCode == "Y") {
            getMessages(dispatch, userInfo);
            go(item.data?._link);
          }
        }
      })
    } else {
      go(item?.data?._link);
    }
  }

  function timeAgo(dateString: string): string {
    // need to convert utc to local
    const date = moment.utc(dateString).toDate();
    return formatDistanceToNow(date, {addSuffix: true, locale: ko});
  }

  // 알림창 바깥을 누르면 닫는다
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (alarmRef.current && !alarmRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const unreadCount = alarmMessages.filter((item: { readYn: string }) => item.readYn === 'N').length;
  const badgeLabel = unreadCount >= 99 ? '99+' : String(unreadCount);
  const badgeClassName = unreadCount > 0 ? 'alarm-badge alarm-badge--active' : 'alarm-badge alarm-badge--empty';

  return (


      <li className={open ? 'alarm active' : 'alarm'} ref={alarmRef}>
        <a href="#" onClick={handleClickAlarmBadge}>
          <Bell className="icon util-icon" aria-hidden="true" />
          <span className="hid">알림</span>
          <em className={badgeClassName}>
            {badgeLabel}
          </em>
        </a>

        <div className="util-over-box">
          <div className="tit">
            <strong className="tit-txt">알림 <ArcButton type={"text"}
                                                      size={"btn-small"}
                                                      shape={"btn-round"}
                                                      color={ButtonColor.btn1}
                                                      text={"전체읽음"}
                                                      onClick={() => handleClickReadAllAlarm()}
            ></ArcButton>
            </strong>

            <a href="#" onClick={handleClickAlarmClose} className="close-btn">
              <i className="las la-times"></i><span className="hid">닫기</span>
            </a>
          </div>
          <div className="cont">
            <ul id="notify-area">
              {alarmMessages?.length === 0
                ?
                  <li className="ac">알림이 없습니다.</li>
                :
                  alarmMessages.map((item: any) => {
                    return <li key={item.messageId} className={item.readYn == "Y" ? "bgY" : "bgN"}>
                      <a href="#" onClick={event => handleClickAlarmNavigate(event, item)} title={item.title}>
                        <div className="img no-profile"></div>
                        <div className="txt">
                          <strong style={{whiteSpace: 'pre-line'}}>{item.body}</strong>
                          <span>{timeAgo((item.regDt))}</span>
                        </div>
                      </a>
                    </li>;
                  })
              }
            </ul>
            <a href="#" className="alarm-all" onClick={e => { e.preventDefault(); setOpen(false); navigate("/alarms"); }}>알림 전체 보기</a>
          </div>
        </div>
      </li>
  )
}